import React from 'react';
import { useIntl } from 'react-intl';
import { components, OptionProps } from 'react-select';

import { Option as IOption } from '../../../types/Option';
import { MenuOption } from '../../Menu/subcomponents/MenuOption';
import { resetGetStyles } from './resetGetStyles';

export const toValue: <V extends unknown>(option: IOption<V>) => V = (option) =>
  option.value;

export const Option = (props: OptionProps<IOption, boolean>) => {
  const intl = useIntl();
  const { data: option, isFocused, isSelected, selectProps } = props;
  const {
    enableOptionIndicator,
    inputValue,
    isAllSelected,
    isIndeterminate,
    isMulti,
  } = selectProps;

  const SELECT_ALL_OPTION: IOption<any> = {
    label: intl.formatMessage({
      id: 'Option.selectAll.label',
      defaultMessage: 'Select All',
      description:
        'Label for the "Select All" option in a multi-select dropdown.',
    }),
    value: '__EDS_SELECT_ALL_VALUE__',
  };

  return (
    <components.Option {...props} getStyles={resetGetStyles}>
      <MenuOption
        enableIndicator={enableOptionIndicator}
        isFocused={isFocused}
        isIndeterminate={
          option.value === SELECT_ALL_OPTION.value && isIndeterminate
        }
        isMulti={isMulti}
        isSelected={
          (option.value === SELECT_ALL_OPTION.value && isAllSelected) ||
          isSelected
        }
        option={option}
        search={inputValue}
      />
    </components.Option>
  );
};
